import React, { useRef } from 'react'

import {
  // https://leafletjs.com/reference-1.6.0.html#path
  CircleMarker,
  LayerGroup
} from 'react-leaflet'

import { institutions } from 'lib/institutions'

export default function MapItem({
  name,
  isCurrent,
  currentPlace,
  updatePlace
}) {
  const itemRef = useRef(null)
  const layerGroupRef = useRef(null)

  const elements = institutions
    .filter(el => {
      return el.name === name
    })
    .map(el => {
      return el.positions.map(p => {
        return (
          <CircleMarker
            ref={itemRef}
            key={p.displayName}
            center={p.position}
            radius={4}
            stroke
            opacity={
              currentPlace === p.displayName ? 0.8 : isCurrent ? 0.5 : 0.2
            }
            weight={isCurrent ? 10 : 5}
            fillOpacity={1}
            color={el.color.hex}
            onMouseOver={() => {
              updatePlace(p.displayName)
            }}
            onMouseOut={() => {
              updatePlace(null)
            }}
          />
        )
      })
    })
  return <LayerGroup ref={layerGroupRef}>{elements}</LayerGroup>
}
